const PRICE_LIST_SEIKATSU_CANCER = {
  ID: "seikatsu-cancer",
  PRICE_M: [
    { AGE: 0, 1: 30, 2: 70, 3: 40, 4: 80 },
    { AGE: 1, 1: 30, 2: 70, 3: 40, 4: 80 },
    { AGE: 2, 1: 30, 2: 70, 3: 40, 4: 80 },
    { AGE: 3, 1: 30, 2: 70, 3: 40, 4: 80 },
    { AGE: 4, 1: 30, 2: 70, 3: 40, 4: 80 },
    { AGE: 5, 1: 30, 2: 80, 3: 50, 4: 100 },
    { AGE: 6, 1: 30, 2: 80, 3: 50, 4: 100 },
    { AGE: 7, 1: 30, 2: 80, 3: 50, 4: 100 },
    { AGE: 8, 1: 30, 2: 80, 3: 50, 4: 100 },
    { AGE: 9, 1: 30, 2: 80, 3: 50, 4: 100 },
    { AGE: 10, 1: 30, 2: 100, 3: 50, 4: 120 },
    { AGE: 11, 1: 30, 2: 100, 3: 50, 4: 120 },
    { AGE: 12, 1: 30, 2: 100, 3: 50, 4: 120 },
    { AGE: 13, 1: 30, 2: 100, 3: 50, 4: 120 },
    { AGE: 14, 1: 30, 2: 100, 3: 50, 4: 120 },
    { AGE: 15, 1: 30, 2: 90, 3: 60, 4: 120 },
    { AGE: 16, 1: 30, 2: 90, 3: 60, 4: 120 },
    { AGE: 17, 1: 30, 2: 90, 3: 60, 4: 120 },
    { AGE: 18, 1: 30, 2: 90, 3: 60, 4: 120 },
    { AGE: 19, 1: 30, 2: 90, 3: 60, 4: 120 },
    { AGE: 20, 1: 40, 2: 70, 3: 90, 4: 120 },
    { AGE: 21, 1: 40, 2: 70, 3: 90, 4: 120 },
    { AGE: 22, 1: 40, 2: 70, 3: 90, 4: 120 },
    { AGE: 23, 1: 40, 2: 70, 3: 90, 4: 120 },
    { AGE: 24, 1: 40, 2: 70, 3: 90, 4: 120 },
    { AGE: 25, 1: 50, 2: 190, 3: 120, 4: 260 },
    { AGE: 26, 1: 50, 2: 190, 3: 120, 4: 260 },
    { AGE: 27, 1: 50, 2: 190, 3: 120, 4: 260 },
    { AGE: 28, 1: 50, 2: 190, 3: 120, 4: 260 },
    { AGE: 29, 1: 50, 2: 190, 3: 120, 4: 260 },
    { AGE: 30, 1: 110, 2: 360, 3: 220, 4: 470 },
    { AGE: 31, 1: 110, 2: 360, 3: 220, 4: 470 },
    { AGE: 32, 1: 110, 2: 360, 3: 220, 4: 470 },
    { AGE: 33, 1: 110, 2: 360, 3: 220, 4: 470 },
    { AGE: 34, 1: 110, 2: 360, 3: 220, 4: 470 },
    { AGE: 35, 1: 170, 2: 640, 3: 380, 4: 850 },
    { AGE: 36, 1: 170, 2: 640, 3: 380, 4: 850 },
    { AGE: 37, 1: 170, 2: 640, 3: 380, 4: 850 },
    { AGE: 38, 1: 170, 2: 640, 3: 380, 4: 850 },
    { AGE: 39, 1: 170, 2: 640, 3: 380, 4: 850 },
    { AGE: 40, 1: 260, 2: 910, 3: 600, 4: 1250 },
    { AGE: 41, 1: 260, 2: 910, 3: 600, 4: 1250 },
    { AGE: 42, 1: 260, 2: 910, 3: 600, 4: 1250 },
    { AGE: 43, 1: 260, 2: 910, 3: 600, 4: 1250 },
    { AGE: 44, 1: 260, 2: 910, 3: 600, 4: 1250 },
    { AGE: 45, 1: 380, 2: 1290, 3: 870, 4: 1780 },
    { AGE: 46, 1: 380, 2: 1290, 3: 870, 4: 1780 },
    { AGE: 47, 1: 380, 2: 1290, 3: 870, 4: 1780 },
    { AGE: 48, 1: 380, 2: 1290, 3: 870, 4: 1780 },
    { AGE: 49, 1: 380, 2: 1290, 3: 870, 4: 1780 },
    { AGE: 50, 1: 500, 2: 1640, 3: 1180, 4: 2320 },
    { AGE: 51, 1: 500, 2: 1640, 3: 1180, 4: 2320 },
    { AGE: 52, 1: 500, 2: 1640, 3: 1180, 4: 2320 },
    { AGE: 53, 1: 500, 2: 1640, 3: 1180, 4: 2320 },
    { AGE: 54, 1: 500, 2: 1640, 3: 1180, 4: 2320 },
    { AGE: 55, 1: 720, 2: 2240, 3: 1670, 4: 3190 },
    { AGE: 56, 1: 720, 2: 2240, 3: 1670, 4: 3190 },
    { AGE: 57, 1: 720, 2: 2240, 3: 1670, 4: 3190 },
    { AGE: 58, 1: 720, 2: 2240, 3: 1670, 4: 3190 },
    { AGE: 59, 1: 720, 2: 2240, 3: 1670, 4: 3190 },
    { AGE: 60, 1: 1120, 2: 3470, 3: 2450, 4: 4800 },
    { AGE: 61, 1: 1120, 2: 3470, 3: 2450, 4: 4800 },
    { AGE: 62, 1: 1120, 2: 3470, 3: 2450, 4: 4800 },
    { AGE: 63, 1: 1120, 2: 3470, 3: 2450, 4: 4800 },
    { AGE: 64, 1: 1120, 2: 3470, 3: 2450, 4: 4800 },
    { AGE: 65, 1: 1530, 2: 4690, 3: 3260, 4: 6420 },
    { AGE: 66, 1: 1530, 2: 4690, 3: 3260, 4: 6420 },
    { AGE: 67, 1: 1530, 2: 4690, 3: 3260, 4: 6420 },
    { AGE: 68, 1: 1530, 2: 4690, 3: 3260, 4: 6420 },
    { AGE: 69, 1: 1530, 2: 4690, 3: 3260, 4: 6420 },
    { AGE: 70, 1: 1930, 2: 6510, 3: 4160, 4: 8740 },
    { AGE: 71, 1: 1930, 2: 6510, 3: 4160, 4: 8740 },
    { AGE: 72, 1: 1930, 2: 6510, 3: 4160, 4: 8740 },
    { AGE: 73, 1: 1930, 2: 6510, 3: 4160, 4: 8740 },
    { AGE: 74, 1: 1930, 2: 6510, 3: 4160, 4: 8740 },
    { AGE: 75, 1: 2180, 2: 7340, 3: 4700, 4: 9860 },
  ],
  PRICE_F: [
    { AGE: 0, 1: 30, 2: 70, 3: 40, 4: 80 },
    { AGE: 1, 1: 30, 2: 70, 3: 40, 4: 80 },
    { AGE: 2, 1: 30, 2: 70, 3: 40, 4: 80 },
    { AGE: 3, 1: 30, 2: 70, 3: 40, 4: 80 },
    { AGE: 4, 1: 30, 2: 70, 3: 40, 4: 80 },
    { AGE: 5, 1: 30, 2: 80, 3: 50, 4: 100 },
    { AGE: 6, 1: 30, 2: 80, 3: 50, 4: 100 },
    { AGE: 7, 1: 30, 2: 80, 3: 50, 4: 100 },
    { AGE: 8, 1: 30, 2: 80, 3: 50, 4: 100 },
    { AGE: 9, 1: 30, 2: 80, 3: 50, 4: 100 },
    { AGE: 10, 1: 30, 2: 100, 3: 50, 4: 120 },
    { AGE: 11, 1: 30, 2: 100, 3: 50, 4: 120 },
    { AGE: 12, 1: 30, 2: 100, 3: 50, 4: 120 },
    { AGE: 13, 1: 30, 2: 100, 3: 50, 4: 120 },
    { AGE: 14, 1: 30, 2: 100, 3: 50, 4: 120 },
    { AGE: 15, 1: 30, 2: 90, 3: 60, 4: 120 },
    { AGE: 16, 1: 30, 2: 90, 3: 60, 4: 120 },
    { AGE: 17, 1: 30, 2: 90, 3: 60, 4: 120 },
    { AGE: 18, 1: 30, 2: 90, 3: 60, 4: 120 },
    { AGE: 19, 1: 30, 2: 90, 3: 60, 4: 120 },
    { AGE: 20, 1: 40, 2: 70, 3: 90, 4: 120 },
    { AGE: 21, 1: 40, 2: 70, 3: 90, 4: 120 },
    { AGE: 22, 1: 40, 2: 70, 3: 90, 4: 120 },
    { AGE: 23, 1: 40, 2: 70, 3: 90, 4: 120 },
    { AGE: 24, 1: 40, 2: 70, 3: 90, 4: 120 },
    { AGE: 25, 1: 50, 2: 190, 3: 120, 4: 260 },
    { AGE: 26, 1: 50, 2: 190, 3: 120, 4: 260 },
    { AGE: 27, 1: 50, 2: 190, 3: 120, 4: 260 },
    { AGE: 28, 1: 50, 2: 190, 3: 120, 4: 260 },
    { AGE: 29, 1: 50, 2: 190, 3: 120, 4: 260 },
    { AGE: 30, 1: 110, 2: 360, 3: 220, 4: 470 },
    { AGE: 31, 1: 110, 2: 360, 3: 220, 4: 470 },
    { AGE: 32, 1: 110, 2: 360, 3: 220, 4: 470 },
    { AGE: 33, 1: 110, 2: 360, 3: 220, 4: 470 },
    { AGE: 34, 1: 110, 2: 360, 3: 220, 4: 470 },
    { AGE: 35, 1: 170, 2: 640, 3: 380, 4: 850 },
    { AGE: 36, 1: 170, 2: 640, 3: 380, 4: 850 },
    { AGE: 37, 1: 170, 2: 640, 3: 380, 4: 850 },
    { AGE: 38, 1: 170, 2: 640, 3: 380, 4: 850 },
    { AGE: 39, 1: 170, 2: 640, 3: 380, 4: 850 },
    { AGE: 40, 1: 260, 2: 910, 3: 600, 4: 1250 },
    { AGE: 41, 1: 260, 2: 910, 3: 600, 4: 1250 },
    { AGE: 42, 1: 260, 2: 910, 3: 600, 4: 1250 },
    { AGE: 43, 1: 260, 2: 910, 3: 600, 4: 1250 },
    { AGE: 44, 1: 260, 2: 910, 3: 600, 4: 1250 },
    { AGE: 45, 1: 380, 2: 1290, 3: 870, 4: 1780 },
    { AGE: 46, 1: 380, 2: 1290, 3: 870, 4: 1780 },
    { AGE: 47, 1: 380, 2: 1290, 3: 870, 4: 1780 },
    { AGE: 48, 1: 380, 2: 1290, 3: 870, 4: 1780 },
    { AGE: 49, 1: 380, 2: 1290, 3: 870, 4: 1780 },
    { AGE: 50, 1: 500, 2: 1640, 3: 1180, 4: 2320 },
    { AGE: 51, 1: 500, 2: 1640, 3: 1180, 4: 2320 },
    { AGE: 52, 1: 500, 2: 1640, 3: 1180, 4: 2320 },
    { AGE: 53, 1: 500, 2: 1640, 3: 1180, 4: 2320 },
    { AGE: 54, 1: 500, 2: 1640, 3: 1180, 4: 2320 },
    { AGE: 55, 1: 720, 2: 2240, 3: 1670, 4: 3190 },
    { AGE: 56, 1: 720, 2: 2240, 3: 1670, 4: 3190 },
    { AGE: 57, 1: 720, 2: 2240, 3: 1670, 4: 3190 },
    { AGE: 58, 1: 720, 2: 2240, 3: 1670, 4: 3190 },
    { AGE: 59, 1: 720, 2: 2240, 3: 1670, 4: 3190 },
    { AGE: 60, 1: 1120, 2: 3470, 3: 2450, 4: 4800 },
    { AGE: 61, 1: 1120, 2: 3470, 3: 2450, 4: 4800 },
    { AGE: 62, 1: 1120, 2: 3470, 3: 2450, 4: 4800 },
    { AGE: 63, 1: 1120, 2: 3470, 3: 2450, 4: 4800 },
    { AGE: 64, 1: 1120, 2: 3470, 3: 2450, 4: 4800 },
    { AGE: 65, 1: 1530, 2: 4690, 3: 3260, 4: 6420 },
    { AGE: 66, 1: 1530, 2: 4690, 3: 3260, 4: 6420 },
    { AGE: 67, 1: 1530, 2: 4690, 3: 3260, 4: 6420 },
    { AGE: 68, 1: 1530, 2: 4690, 3: 3260, 4: 6420 },
    { AGE: 69, 1: 1530, 2: 4690, 3: 3260, 4: 6420 },
    { AGE: 70, 1: 1930, 2: 6510, 3: 4160, 4: 8740 },
    { AGE: 71, 1: 1930, 2: 6510, 3: 4160, 4: 8740 },
    { AGE: 72, 1: 1930, 2: 6510, 3: 4160, 4: 8740 },
    { AGE: 73, 1: 1930, 2: 6510, 3: 4160, 4: 8740 },
    { AGE: 74, 1: 1930, 2: 6510, 3: 4160, 4: 8740 },
    { AGE: 75, 1: 2180, 2: 7340, 3: 4700, 4: 9860 },
  ],
};
export { PRICE_LIST_SEIKATSU_CANCER };
